import React from 'react';
import StatusMessage from '../../../../lib/status_message';
import StudyItemCard from '../../../../organisms/study_item_card';
import { DefaultButton } from '@magoosh/lib/button';
import { useStudyPlanContext } from '../../context';
import { useTabs } from '@magoosh/gre/adaptive_prep_v1/lib/tabs';

export const CompletedTab: React.FC = () => {
  const { completedItems } = useStudyPlanContext().studyPlanState;
  const { setActiveTab } = useTabs();

  return (
    <>
      {completedItems.length === 0 ? (
        <StatusMessage
          headline="No Completed Activities to Display"
          text="When you complete activities from your To Do list, you’ll be able to see them here.">
          <DefaultButton
            onClick={() => {
              setActiveTab('todo');
            }}>
            View To Do
          </DefaultButton>
        </StatusMessage>
      ) : (
        completedItems.map((item, index) => (
          <StudyItemCard
            key={index}
            section={item.section}
            variant={item.type === 'Segment' ? 'secondary' : 'info'}
            headline={item.headline}
            subheadline={item.subheadline}
            significanceLevel={item.significanceLevel}
            minutes={item.estimatedTimeMinutes}
            id={item.id}
            date={item.completedAt}
            shortDescription={item.shortDescription}
            primaryCTA={{
              ...item.primaryCta,
              variant: item.primaryCta ? 'default' : ''
            }}
          />
        ))
      )}
    </>
  );
};

export default CompletedTab;
